import React, { useEffect, useRef } from 'react';

const AlwaysScrollBottom = () => {
    const scrollRef = useRef<null | HTMLDivElement>(null);
    useEffect(() => {
        scrollRef.current?.scrollIntoView();
    });
    return <div ref={scrollRef} />;
};
export default AlwaysScrollBottom;